import React, { useRef, Children, Component } from 'react';
import { motion, useInView } from 'framer-motion';
function UNFCCCLogo() {
  return <svg viewBox="0 0 140 40" className="h-16 w-auto" aria-label="UNFCCC" data-id="element-870">
      <rect x="0" y="8" width="24" height="24" rx="4" fill="#009EDB" data-id="element-871" />
      <path d="M6 20 L12 14 L18 20 L12 26Z" fill="white" data-id="element-872" />
      <text x="30" y="26" fontFamily="Inter, system-ui, sans-serif" fontSize="14" fontWeight="700" fill="#1B4332" letterSpacing="-0.5" data-id="element-873">
        UNFCCC
      </text>
    </svg>;
}
function VerraLogo() {
  return <svg viewBox="0 0 100 40" className="h-16 w-auto" aria-label="Verra" data-id="element-874">
      <circle cx="14" cy="20" r="10" fill="none" stroke="#00A651" strokeWidth="3" data-id="element-875" />
      <path d="M9 20 L13 25 L20 15" stroke="#00A651" strokeWidth="2.5" fill="none" strokeLinecap="round" strokeLinejoin="round" data-id="element-876" />
      <text x="30" y="26" fontFamily="Inter, system-ui, sans-serif" fontSize="16" fontWeight="700" fill="#1B4332" letterSpacing="-0.3" data-id="element-877">
        Verra
      </text>
    </svg>;
}
function GoldStandardLogo() {
  return <svg viewBox="0 0 170 40" className="h-16 w-auto" aria-label="Gold Standard" data-id="element-878">
      <circle cx="14" cy="20" r="11" fill="#C5A028" data-id="element-879" />
      <text x="10" y="25" fontFamily="Inter, system-ui, sans-serif" fontSize="13" fontWeight="800" fill="white" data-id="element-880">
        G
      </text>
      <text x="30" y="26" fontFamily="Inter, system-ui, sans-serif" fontSize="13" fontWeight="700" fill="#1B4332" letterSpacing="-0.3" data-id="element-881">
        Gold Standard
      </text>
    </svg>;
}
function CDPLogo() {
  return <svg viewBox="0 0 80 40" className="h-16 w-auto" aria-label="CDP" data-id="element-882">
      <rect x="0" y="8" width="24" height="24" rx="12" fill="#1B1B1B" data-id="element-883" />
      <text x="5" y="25" fontFamily="Inter, system-ui, sans-serif" fontSize="11" fontWeight="800" fill="white" letterSpacing="0.5" data-id="element-884">
        CD
      </text>
      <text x="30" y="27" fontFamily="Inter, system-ui, sans-serif" fontSize="18" fontWeight="800" fill="#1B4332" letterSpacing="1" data-id="element-885">
        CDP
      </text>
    </svg>;
}
function UCDALogo() {
  return <svg viewBox="0 0 120 40" className="h-16 w-auto" aria-label="UCDA" data-id="element-886">
      <rect x="0" y="8" width="24" height="24" rx="4" fill="#2D6A4F" data-id="element-887" />
      <circle cx="12" cy="16" r="4" fill="white" data-id="element-888" />
      <path d="M8 24 Q12 28 16 24" stroke="white" strokeWidth="1.5" fill="none" data-id="element-889" />
      <text x="30" y="26" fontFamily="Inter, system-ui, sans-serif" fontSize="14" fontWeight="700" fill="#1B4332" letterSpacing="0.5" data-id="element-890">
        UCDA
      </text>
    </svg>;
}
function WorldBankLogo() {
  return <svg viewBox="0 0 150 40" className="h-12 w-auto" aria-label="World Bank" data-id="element-891">
      <circle cx="14" cy="20" r="11" fill="none" stroke="#002244" strokeWidth="2" data-id="element-892" />
      <line x1="3" y1="20" x2="25" y2="20" stroke="#002244" strokeWidth="1.5" data-id="element-893" />
      <line x1="14" y1="9" x2="14" y2="31" stroke="#002244" strokeWidth="1.5" data-id="element-894" />
      <text x="30" y="25" fontFamily="Inter, system-ui, sans-serif" fontSize="13" fontWeight="700" fill="#1B4332" letterSpacing="-0.3" data-id="element-895">
        World Bank
      </text>
    </svg>;
}
const logos = [{
  id: 'unfccc',
  Component: UNFCCCLogo
}, {
  id: 'verra',
  Component: VerraLogo
}, {
  id: 'gold-standard',
  Component: GoldStandardLogo
}, {
  id: 'ucda',
  Component: UCDALogo
}];
export function TrustedBy() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-60px'
  });
  return <section ref={ref} className="w-full bg-[#FAFDF7] py-16 sm:py-20 border-t border-carbon-geo" data-id="element-896">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-897">
        <motion.p className="text-center text-sm font-semibold uppercase tracking-widest text-carbon-mid/60 mb-10" initial={{
        opacity: 0
      }} animate={isInView ? {
        opacity: 1
      } : {}} transition={{
        duration: 0.5
      }} data-id="element-898">
          Trusted by leading organizations
        </motion.p>

        <motion.div className="grid grid-cols-2 gap-8 items-center justify-items-center sm:flex sm:flex-wrap sm:justify-center sm:gap-12 lg:gap-14" initial="hidden" animate={isInView ? 'visible' : 'hidden'} variants={{
        hidden: {},
        visible: {
          transition: {
            staggerChildren: 0.08
          }
        }
      }} data-id="element-899">
          {logos.map(({
          id,
          Component
        }) => <motion.div key={id} className="transition-all duration-300" variants={{
          hidden: {
            opacity: 0,
            y: 10
          },
          visible: {
            opacity: 0.7,
            y: 0,
            transition: {
              duration: 0.5,
              ease: 'easeOut'
            }
          }
        }} whileHover={{
          opacity: 1
        }} data-id="element-900">
              <Component data-id="element-901" />
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}